import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE } from '../config/api';

const AdminNav = ({ pendingPayments }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [pendingCount, setPendingCount] = useState(pendingPayments ?? 0);

  useEffect(() => {
    if (pendingPayments !== undefined) {
      setPendingCount(pendingPayments);
      return;
    }
    // Fetch on mount if not provided by parent
    const token = localStorage.getItem('adminToken');
    if (!token) return;
    fetch(`${API_BASE}/bkash/pending-count`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((r) => r.json())
      .then((d) => { if (d.success) setPendingCount(d.count); })
      .catch(() => {});
  }, [pendingPayments]);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    window.location.href = '/admin/login';
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="admin-nav">
      <div className="admin-nav-top">
        <div className="admin-nav-brand">
          <h1>MegaGenie Admin</h1>
        </div>
        <button
          className={`admin-hamburger${menuOpen ? ' active' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      <div className={`admin-nav-links${menuOpen ? ' open' : ''}`}>
        <Link to="/admin" onClick={closeMenu}>Dashboard</Link>
        <Link to="/admin/categories" onClick={closeMenu}>Categories</Link>
        <Link to="/admin/products" onClick={closeMenu}>Products</Link>
        <Link to="/admin/showcase" onClick={closeMenu}>Showcase Sections</Link>
        <Link to="/admin/orders" onClick={closeMenu}>Orders</Link>
        <Link to="/admin/payments" onClick={closeMenu} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          bKash Payments
          {pendingCount > 0 && (
            <span style={{
              background: '#e2136e', color: '#fff',
              borderRadius: '12px', padding: '1px 7px',
              fontSize: '11px', fontWeight: 700, lineHeight: '18px'
            }}>
              {pendingCount}
            </span>
          )}
        </Link>
        <a href="/" rel="noopener noreferrer" onClick={closeMenu}>View Website</a>
        <button onClick={handleLogout} className="logout-btn">Logout</button>
      </div>
    </nav>
  );
};

export default AdminNav;
